export default __webpack_public_path__ + "/assets/chisiamo-text-02.png";